//@ts-nocheck
import axios from "axios";
import { accessToken } from "../utils/sessionKey";
import { toast } from "react-toastify";

const API_ROOT: string = "https://goldshop.dibsolutions.com.au/api";

export default API_ROOT;

//create axios instance
export const instance = axios.create({
  baseURL: `${API_ROOT}`,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${accessToken()}`,
  },
});

let isRefreshing = false;
let failedQueue = [];

// Request interceptor
instance.interceptors.request.use(
  function (config) {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Function to refresh the access token
const refreshAccessToken = async () => {
  if (isRefreshing) {
    return new Promise((resolve, reject) => {
      failedQueue.push({ resolve, reject });
    });
  }
  isRefreshing = true;
  try {
    const refreshToken = localStorage.getItem("refreshToken");
    if (!refreshToken) throw new Error("No refresh token found");

    const response = await axios.post(`${API_ROOT}/token/refresh/`, {
      refresh: refreshToken,
    });
    const { access, refresh } = response.data;

    // Update the access and refresh tokens in localStorage
    localStorage.setItem("token", access);
    localStorage.setItem("refreshToken", refresh); // Optional: update refresh token if your backend provides a new one

    // Update axios default headers
    instance.defaults.headers.common["Authorization"] = `Bearer ${access}`;

    // Process the failed queue
    failedQueue.forEach((promise) => promise.resolve(access));
    failedQueue = [];
    isRefreshing = false;
  } catch (error) {
    failedQueue.forEach((promise) => promise.reject(error));
    failedQueue = [];
    isRefreshing = false;
    console.error("Error refreshing token:", error);
    // Redirect to login if token refresh fails
    window.location.href = "/login";
  }
};

// let interval = null;
// // Schedule the token refresh just before it expires (e.g., 4.5 minutes)
// const scheduleTokenRefresh = () => {
//   if (interval) {
//     clearInterval(interval);
//   }
//   const expirationTime = 5 * 60 * 1000; // 5 minutes in milliseconds
//   const refreshTime = expirationTime - 20 * 1000; // Refresh 30 seconds before expiration
//   interval = setInterval(refreshAccessToken, refreshTime);
// };

// // Call this function initially to start the token refresh process
// scheduleTokenRefresh();

instance.interceptors.response.use(
  function (response) {
    return response;
  },
  async function (error) {
    const { response } = error;
    if (response) {
      if (response.status === 404) {
        toast.error("Not Found");
      } else if (response.status === 401) {
        // Trigger token refresh and retry the original request
        await refreshAccessToken();
        const token = localStorage.getItem("token");
        if (token) {
          error.config.headers.Authorization = `Bearer ${token}`;
          return instance(error.config);
        }
      } else {
        toast.error(response.data.msg);
      }
    }
    return Promise.reject(error);
  }
);

export const getApiData = async (url, param = null) => {
  let response;
  try {
    response = await instance({
      method: "GET",
      url: `${url}`,
      params: param,
      headers: {
        Authorization: `Bearer ${accessToken()}`,
      },
      transformResponse: [
        function (responseData) {
          // Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e) {
    return e.response;
  }
  return response;
};

export const postApiData = async (data) => {
  const { url, formData, setError } = data;
  let response;
  try {
    response = await instance({
      method: "POST",
      url: `${url}`,
      data: formData,
      headers: {
        Authorization: `JWT ${accessToken()}`,
      },
      transformResponse: [
        function (responseData) {
          // Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key)) {
        setError(key, { type: "custom", message: e.response?.data[key] });
      }
    }
    return e.response;
  }
  return response;
};

export const putApiData = async (data) => {
  const { url, formData, setError } = data;

  let response;
  try {
    response = await instance({
      method: "PATCH",
      url: `${url}`,
      data: formData,
      headers: {
        Authorization: `Bearer ${accessToken()}`,
      },
      transformResponse: [
        function (responseData) {
          //Do whatever you want to transform the data
          return JSON.parse(responseData);
        },
      ],
    });
  } catch (e) {
    for (const key in e.response?.data) {
      if (e.response?.data.hasOwnProperty(key)) {
        setError(key, { type: "custom", message: e.response?.data[key] });
      }
    }
    return e.response;
  }
  return response;
};

export const deleteApiData = async ({ url }) => {
  let response;
  response = await instance({
    method: "DELETE",
    url: url,
    headers: {
      Authorization: `Bearer ${accessToken()}`,
    },
  });
  return response;
};
